import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets/components';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-enterprise-support-section',
  imports: [TuiIcon, SectionHeaderComponent],
  templateUrl: './enterprise-support-section.component.html',
  styleUrl: './enterprise-support-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnterpriseSupportSectionComponent {}
